import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { PersonResponse } from "~types/person.ts";
import type { UpsertPersonForm } from "../types/upsertPersonForm";

type UpsertPersonApiRequest = Omit<UpsertPersonForm, "dob" | "deceased" | "personId" | "externalId" | "updated" | "added"> & {
  dob: string | null;
  deceased: string | null;
};
export const useUpdatePerson = (personId: string) => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const notification = useNotification();

  return useMutation<PersonResponse, Error, UpsertPersonApiRequest>({
    mutationFn: async (updateData: UpsertPersonApiRequest) => {
      return await request(`${sport}/o/${organizationId}/persons/${personId}`, {
        method: "PUT",
        body: updateData,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["person", sport, organizationId, personId],
      });

      notification.success({
        message: formatMessage({ id: "person.update.success" }),
        placement: "bottomRight",
      });
    },
  });
};
